import { normalizeAreaId } from './normalize.js';
import { columnIndex } from './types.js';
import { framePsuCountMap, validateMicrodataTable } from './validate.js';
export function tableToRespondents(table, roles) {
    const issues = validateMicrodataTable(table, roles);
    if (issues.some((i) => i.severity === 'error')) {
        return { respondents: [], issues };
    }
    const psuPopulationCounts = roles.psuPopulation
        ? framePsuCountMap(table, roles)
        : undefined;
    const idx = {
        area: columnIndex(table, roles.area),
        weight: columnIndex(table, roles.weight),
        stratum: roles.stratum ? columnIndex(table, roles.stratum) : -1,
        psu: roles.psu ? columnIndex(table, roles.psu) : -1,
        indicators: roles.indicators.map((n) => columnIndex(table, n)),
        subgroups: (roles.subgroups ?? []).map((n) => columnIndex(table, n)),
    };
    const respondents = [];
    for (const row of table.rows) {
        const areaCell = row[idx.area];
        if (areaCell === null || areaCell === '')
            continue; // warned already
        const outcomes = {};
        roles.indicators.forEach((name, k) => {
            const v = row[idx.indicators[k]];
            outcomes[name] = typeof v === 'number' ? v : null;
        });
        const subgroups = {};
        (roles.subgroups ?? []).forEach((name, k) => {
            subgroups[name] = row[idx.subgroups[k]] ?? null;
        });
        const stratum = idx.stratum >= 0 ? row[idx.stratum] : null;
        const psu = idx.psu >= 0 ? row[idx.psu] : null;
        respondents.push({
            areaId: normalizeAreaId(areaCell),
            weight: row[idx.weight],
            ...(stratum !== null && stratum !== undefined
                ? { stratum: stratum }
                : {}),
            ...(psu !== null && psu !== undefined
                ? { psu: psu }
                : {}),
            outcomes,
            subgroups,
        });
    }
    return {
        respondents,
        issues,
        ...(psuPopulationCounts !== undefined ? { psuPopulationCounts } : {}),
    };
}
//# sourceMappingURL=microdata.js.map